import configureStoreDev from "./configureStore.dev";

/**
 * Export the environment-selected configureStore and history helpers.
 */
const selectedConfigureStore = configureStoreDev;

export const { configureStore } = selectedConfigureStore;

export const { history } = selectedConfigureStore;
